import { IconCheckmark } from 'components/Shared/Icon/themes/PP/iconCheckmark';
import { NO_ELEMENT } from 'utils';
import styles from './productProperties.scss';

interface PropertyProps {
  property?: string;
}

interface PropertiesProps {
  props?: string[];
}

const ProductProperty = ({ property }: PropertyProps) => {
  return (
    <div className={styles.productProperty}>
      <div className={styles.icon}>
        <IconCheckmark />
      </div>
      <p className={styles.property}>{property}</p>
    </div>
  );
};

export const ProductProperties = ({ props }: PropertiesProps) => {
  if (props === undefined || props.length === 0) {
    return NO_ELEMENT;
  }

  return (
    <div className={styles.propertyContainer}>
      {props.map(property => (
        <ProductProperty key={property} property={property} />
      ))}
    </div>
  );
};
